// extracted by mini-css-extract-plugin
export var borderRadius = "_9x-4";
export var large = "_9x-3";
export var logoContainer = "_9x-0";
export var nameLogo = "_9x-2";
export var small = "_9x-1";